import React from "react";
import { Checkbox, Tooltip, Typography, useTheme } from "@mui/material";
import { BulkActionBarProps } from "./types";
import {
  BarContainer,
  LeftGroup,
  RightGroup,
  BulkActionBtn,
  IconActionBtn,
} from "./style";

const BulkActionBarCst: React.FC<BulkActionBarProps> = ({
  selectedCount,
  checked,
  indeterminate = false,
  onToggleAll,
  selectedLabel,
  actions = [],
  iconActions = [],
}) => {
  const theme = useTheme();
  const hasSelection = selectedCount > 0;

  return (
    <BarContainer>
      <LeftGroup>
        {onToggleAll && (
          <Checkbox
            checked={!!checked}
            indeterminate={indeterminate}
            onChange={(e) => onToggleAll(e.target.checked)}
            sx={{
              padding: "4px",
              color: theme.palette.divider,
              "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                color: theme.palette.primary.main,
              },
            }}
          />
        )}
        <Typography
          sx={{
            fontSize: "13px",
            color: theme.palette.text.primary,
          }}
        >
          {selectedLabel(selectedCount)}
        </Typography>

        {actions.map((action) => (
          <BulkActionBtn
            key={action.key}
            disabled={
              action.disabled || (!hasSelection && !action.alwaysEnabled)
            }
            onClick={action.onClick}
            variant="outlined"
          >
            {action.label}
            {action.icon}
          </BulkActionBtn>
        ))}
      </LeftGroup>

      {iconActions.length > 0 && (
        <RightGroup>
          {iconActions.map((action) => {
            const button = (
              <IconActionBtn
                disabled={action.disabled || !hasSelection}
                onClick={action.onClick}
              >
                {action.icon}
              </IconActionBtn>
            );
            return action.tooltip ? (
              <Tooltip key={action.key} title={action.tooltip}>
                <span>{button}</span>
              </Tooltip>
            ) : (
              <span key={action.key}>{button}</span>
            );
          })}
        </RightGroup>
      )}
    </BarContainer>
  );
};

export default BulkActionBarCst;
